// extracted by mini-css-extract-plugin
export default {"content":"style_content__Wtl6b","leftSide":"style_leftSide__o2UeH","rightSide":"style_rightSide__73HKx","type":"style_type__6WmPd","videoPlayer":"style_videoPlayer__p31CS"};